module.exports = __webpack_public_path__ + "static/media/2.c942cf2c.jpg";